
var vskoBlockList = angular.module('vskoBlockList', []);

// Block List
vskoBlockList.directive('vskoBlockList', [function () {
  'use strict';
  return {
    restrict: 'E',
    template: require('./vsko-block-list.html'),
    transclude: {
      slotContent: 'vskoBlockListItem'
    },
    scope: {
    },
    controller:  ['$scope', function ($scope) {
    }]
  };
}])
// Block List Item
.directive('vskoBlockListItem', [function () {
  'use strict';

  return {
    require: '^vskoBlockList',
    restrict: 'E',
    template: require('./vsko-block-list-item.html'),
    scope: {
      heading: '@?',
      headingType: '@?', // big or bold
      description: '@?',
      avatar: '@?',
      blockIcon: '@?',
      disclosure: '=?'
    },
    controller: ['$scope', function ($scope) {
      $scope.href = $scope.href || '#';
      $scope.headingType = $scope.headingType || 'big';
    }]
  };
}])

// filter function to get short avatar from long names
.filter('initials', function () {
  'use strict';

  return function (text) {
    if (!text) { return ""; }

    var initials = text.toUpperCase();

    if (initials.length > 2) {
        initials = initials.match(/\b\w/g) || [];
        initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    }

    return initials;
  };
});
